import React from 'react';
import PageLayout from '../components/common/PageLayout';
import BookingList from '../components/BookingList';

const BookingListPage = () => (
  <PageLayout
    title="Booking List"
    showBookingSectionTabs
    navLinks={[
      { url: '/booking/reservation/', label: 'Reservation' },
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <BookingList />
  </PageLayout>
);

export default BookingListPage;
